import config from "../../utils/config";
import client from "./client";

/**
 * Paths are relative to axios base: `${REACT_APP_BASE_URL}/payout`.
 * Full URL example: https://host/api/payout/amlbot/create
 */
export const AMLBOT_KYC_PATHS = {
  create: "/amlbot/create",
  status: "/amlbot",
};

export const isPayeeKycAmlbot = () => config.payeeKycProvider === "amlbot";

export const createAmlbotApplicant = () =>
  client.post(AMLBOT_KYC_PATHS.create);

export const checkAmlbotStatus = () => client.get(AMLBOT_KYC_PATHS.status);

const extractAmlbotLink = (response) => {
  const inner = response?.result?.data;
  const result = response?.result;

  if (inner && typeof inner === "object") {
    const link =
      inner.link || inner.formUrl || inner.url || inner.verificationUrl;
    if (typeof link === "string" && link) {
      return link;
    }
  }
  if (typeof inner === "string" && /^https?:\/\//i.test(inner)) {
    return inner;
  }
  if (typeof result?.link === "string" && result.link) {
    return result.link;
  }
  if (typeof response?.link === "string" && response.link) {
    return response.link;
  }
  return null;
};

/**
 * Parse the AML Bot create response per integration guide.
 * @returns {{ link: string } | null}
 */
export const parseAmlbotCreateResponse = (response) => {
  const link = extractAmlbotLink(response);
  return link ? { link } : null;
};
